import { FC, useEffect, useState } from 'react';

import Code from '../../../Shared/Code';
import DisplayEvent from '../../../Shared/DisplayEvent';
import ContentGenerator from '../../../Shared/ContentGenerator';
import Modal from '../../../Shared/Modal';

import { useChatContext } from '../../ChatController/ChatController.context';

import { Content } from '../../../../types/tour';

export type Props = {
  setComplete: (stepIndex: number, parentIndex: number) => void;
  content: Content;
};

const codeSample = `
channel.on("message.new", event => {
  logEvent(event);
});

await channel.sendMessage({
  text: "What is the medieval equivalent of tabs vs spaces?",
});
`;

export const Step7: FC<Props> = ({ setComplete, content }: Props) => {
  const { state, startListening, sendListeningMessage } = useChatContext();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Start listening to events after component loads
    startListening();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (state?.event) {
      setShowModal(true);
    }
  }, [state?.event]);

  const run = async () => {
    await sendListeningMessage();
    setComplete(7, 6);
  };

  return (
    <ContentGenerator
      content={content}
      code={
        <Code language="jsx" footer={{ label: 'Start Listening', run }}>
          {codeSample}
        </Code>
      }
    >
      {showModal && (
        <Modal title="New message event" onClose={() => setShowModal(false)}>
          {JSON.stringify(state?.event, null, 2)}
        </Modal>
      )}
    </ContentGenerator>
  );
};
